var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUbrUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ui ui-ubr_update",
    viewBox: "0 0 80 80",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.772 67.6c-15.2 2.6-29.7-7.7-32.3-22.9-1.1-6.6.1-13.3 3.5-19l.7 4 4-.7-1.9-10.8-10.5 2 .7 4 3.7-.6c-3.9 6.4-5.4 14.2-4.1 21.8 2.6 15.6 16.2 26.6 31.5 26.6 1.8 0 3.6-.2 5.4-.5 2.9-.5 5.6-1.4 8.2-2.6l-1.6-3.6c-2.3 1.1-4.8 1.8-7.3 2.3zm22.8-11.2c3.9-6.5 5.4-14.2 4.1-21.8-3-17.4-19.6-29.1-37-26.1-2.9.5-5.6 1.4-8.2 2.6l1.7 3.6c2.3-1.1 4.7-1.8 7.2-2.3 15.2-2.6 29.7 7.7 32.3 22.9 1.1 6.6-.1 13.3-3.5 18.9l-.7-4-4 .7 1.8 10.6 10.5-1.8-.7-4-3.5.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrUpdate);
export default __webpack_public_path__ + "static/media/ubr_update.6a227e75395a4ce18fa6aee7ac27ade2.svg";
export { ForwardRef as ReactComponent };